import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const BLOG_URL = 'https://blog.rocketproxy.io/services';

export function Footer() {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      setIsScrolled(scrollPosition + windowHeight >= documentHeight - 100 || scrollPosition > 10);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <footer
      className={`dx-site-footer relative z-10 mt-auto w-full ${
        isScrolled ? 'is-scrolled' : ''
      }`}
    >
      <div className="dx-site-footer__card">
        <div className="dx-site-footer__brand">
          <div className="dx-site-footer__brand-row">
            <span className="dx-site-footer__name">Rocket Proxy</span>
            <img
              src="https://res.cloudinary.com/dwhpimotj/image/upload/v1758543752/logo_pnm9g9.png"
              alt=""
              className="dx-site-footer__logo"
            />
          </div>
          <p className="dx-site-footer__tagline">{t('footer.tagline')}</p>
        </div>

        <div className="dx-site-footer__cols">
          <div className="dx-site-footer__col">
            <h3>{t('footer.groups.explore')}</h3>
            <ul>
              <li>
                <Link to="/buy-proxies">{t('footer.links.buyProxies', 'Buy proxies')}</Link>
              </li>
              <li>
                <Link to="/residential-proxies">{t('footer.links.residential', 'Residential proxies')}</Link>
              </li>
              <li>
                <Link to="/mobile-proxies">{t('footer.links.mobile', 'Mobile proxies')}</Link>
              </li>
              <li>
                <Link to="/isp-proxies">{t('footer.links.isp', 'ISP proxies')}</Link>
              </li>
              <li>
                <Link to="/datacenter-proxies">{t('footer.links.datacenter', 'Datacenter proxies')}</Link>
              </li>
              <li>
                <Link to="/reseller">{t('footer.links.reseller')}</Link>
              </li>
              <li>
                <a href="/api-docs.html" target="_blank" rel="noreferrer">
                  {t('footer.links.apiDocs')}
                </a>
              </li>
              <li>
                <a href={BLOG_URL} target="_blank" rel="noreferrer">
                  {t('footer.links.blog')}
                </a>
              </li>
            </ul>
          </div>

          <div className="dx-site-footer__col">
            <h3>{t('footer.groups.companySupport')}</h3>
            <ul>
              <li>
                <Link to="/about">{t('footer.links.about')}</Link>
              </li>
              <li>
                <Link to="/support">{t('footer.links.contactSupport')}</Link>
              </li>
              <li>
                <Link to="/faq">{t('footer.links.faq')}</Link>
              </li>
              <li>
                <Link to="/terms">{t('footer.links.terms')}</Link>
              </li>
              <li>
                <Link to="/privacy">{t('footer.links.privacy')}</Link>
              </li>
              <li>
                <Link to="/refund-policy">{t('footer.links.refund')}</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="dx-site-footer__bottom">
          <p>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  );
}
